import Vue from "vue";
import VueI18n from "vue-i18n";
import alb from "./lan/zh";
import en from "./lan/en";
Vue.use(VueI18n); // 使用  I18n

const i18n = new VueI18n({
  locale: "en", // 设置默认语言
  messages: {
    en,
    alb,
  },
});
// 添加一个方法来更改语言
i18n.changeLanguage = function (lang) {
  this.locale = lang;
};

export default i18n;
